/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import type { Voucher } from './Voucher';
/**
 * 
 * @export
 * @interface VoucherCode
 */
export interface VoucherCode {
    /**
     * 
     * @type {number}
     * @memberof VoucherCode
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VoucherCode
     */
    code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VoucherCode
     */
    used?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VoucherCode
     */
    usedBy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VoucherCode
     */
    voucherId?: number;
    /**
     * 
     * @type {User}
     * @memberof VoucherCode
     */
    usedByNavigation?: User;
    /**
     * 
     * @type {Voucher}
     * @memberof VoucherCode
     */
    voucher?: Voucher;
}

/**
 * Check if a given object implements the VoucherCode interface.
 */
export function instanceOfVoucherCode(value: object): value is VoucherCode {
    return true;
}

export function VoucherCodeFromJSON(json: any): VoucherCode {
    return VoucherCodeFromJSONTyped(json, false);
}

export function VoucherCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherCode {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'used': json['used'] == null ? undefined : json['used'],
        'usedBy': json['usedBy'] == null ? undefined : json['usedBy'],
        'voucherId': json['voucherId'] == null ? undefined : json['voucherId'],
        'usedByNavigation': json['usedByNavigation'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['usedByNavigation']),
        'voucher': json['voucher'] == null ? undefined : (require('./Voucher') as typeof import('./Voucher')).VoucherFromJSON(json['voucher']),
    };
}

export function VoucherCodeToJSON(json: any): VoucherCode {
    return VoucherCodeToJSONTyped(json, false);
}

export function VoucherCodeToJSONTyped(value?: VoucherCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'used': value['used'],
        'usedBy': value['usedBy'],
        'voucherId': value['voucherId'],
        'usedByNavigation': (require('./User') as typeof import('./User')).UserToJSON(value['usedByNavigation']),
        'voucher': (require('./Voucher') as typeof import('./Voucher')).VoucherToJSON(value['voucher']),
    };
}

